module.exports = __webpack_public_path__ + "img/SalarySlipManagement.5e04bdef.svg";